export default "__VITE_ASSET__C4VKyd49__"